export default __webpack_public_path__ + "static/media/paper-plane-in-app.20253529.png";